import React, { useState } from 'react'
import useSound from 'use-sound';
import "./music.scss"
import Epic from "../../sounds/motivation/Epic.mp3"
import { useTranslation } from 'react-i18next';
export default function Music() {
    const {t} = useTranslation();

    const [isChecked, setIsChecked] = React.useState(false);
    const [volume] = useState(0.1);
    const [play,{stop}] = useSound(Epic,{volume});

    const Update = ()=>{
      document.documentElement.style.setProperty("--On",`"${t("InspirationOn")}"`);
      document.documentElement.style.setProperty("--Off", `"${t("InspirationOff")}"`);
    }

    Update();
    

  return (


    <div className='music'>
        <span className="switcher switcher-2">
            <input type="checkbox" id="switcher-2" onChange={()=>setIsChecked(!isChecked)}
            onMouseUp={()=> {!isChecked? play() : stop()}}/>
            <label htmlFor="switcher-2"></label>
        </span>
    </div>
  )
}
